import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, Chapter } from "./Reveal";

const FAQS = [
  {
    q: "How far in advance should I order?",
    a: "Custom cakes are subject to availability, so submitting your request as early as possible is recommended.",
  },
  {
    q: "Does submitting an inquiry reserve my date?",
    a: "No. Your order and event date are not confirmed until Bella Bells Cakes has reviewed the request and confirmed your booking.",
  },
  {
    q: "Can I send inspiration pictures?",
    a: "Absolutely. You can upload inspiration photos directly through the inquiry form \u2014 they help us understand your style.",
  },
  {
    q: "Are prices listed on the website final?",
    a: "No. Cake prices shown are starting prices. Final pricing depends on cake size, design, decorations, and customization.",
  },
  {
    q: "Where are you located?",
    a: "Bella Bells Cakes is a licensed bakery based in San Diego, California.",
  },
  {
    q: "Do you make cupcakes and macarons?",
    a: "Yes. Cupcakes are $30\u2013$35 per dozen and macarons are $25\u2013$30 per dozen.",
  },
];

const FAQ = () => (
  <section id="faq" className="scroll-mt-24 py-24 sm:py-32" data-testid="faq-section">
    <div className="mx-auto max-w-3xl px-5 sm:px-8">
      <Reveal>
        <Chapter num="09" label="FAQ" />
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-6 font-display text-4xl font-light leading-tight tracking-tight text-[#2D2422] sm:text-5xl">
          Sweet questions, answered
        </h2>
      </Reveal>

      <Reveal delay={0.2} className="mt-12">
        <Accordion type="single" collapsible data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`item-${i}`} className="border-[#E8D8D3]">
              <AccordionTrigger
                className="py-6 text-left font-display text-xl font-normal text-[#2D2422] hover:text-[#C48B71] hover:no-underline sm:text-2xl"
                data-testid={`faq-question-${i + 1}`}
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-base leading-relaxed text-[#5C4B47]" data-testid={`faq-answer-${i + 1}`}>
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default FAQ;
